module.exports = __webpack_public_path__ + "img/N660-2-EN.e262ea40.png";